import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import './style/index.css';
import './style/navbar.css';
import './style/footer.css';
import './style/not-found.css';
import './style/login.css';
import './style/home.css';
import './style/text.css';
import './style/mail-viwer.css';
import './style/solutions.css';
import './style/solution.css';

import Navbar from './widgets/navbar';
import Footer from './widgets/footter';
import theme from './style/theme';
import NotFoundPage from './routes/not-found';

import './i18n';
import AuthProviderLoging from './firebase/auth-provider.tsx';
import LoginPage from './routes/login.jsx';
import LogoutPage from './routes/logout.jsx';
import HomePage from './routes/home.jsx';
import UsersPage from './routes/users/users.jsx';
import BalancePage from './routes/balance/balance.jsx';
import Mails from './routes/mails/mails.jsx';
import HasPermissions from './widgets/permissions.jsx';
import LocalMails from './routes/mails/local.jsx';
import MailDetails from './routes/mails/mail-details.jsx';
import SolutionsPage from './routes/solutions/solutions.jsx';
import SolutionPage from './routes/solutions/solution.jsx';

const Wrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return children;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div style={{'--primary': theme.palette.primary.main, '--primary-light': theme.palette.primary.light, '--primary-dark': theme.palette.primary.dark, '--secondary': theme.palette.secondary.main, '--secondary-light': theme.palette.secondary.light, '--secondary-dark': theme.palette.secondary.dark, '--card-bg': '#ebf4f8', '--h2-color': '#666', '--data-color':'#3a5a78'}}>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700&family=Open+Sans:wght@400;600&display=swap" rel="stylesheet"></link>
    <link href="https://fonts.googleapis.com/css2?family=Spline+Sans+Mono:ital,wght@0,300..700;1,300..700&display=swap" rel="stylesheet"></link>
    <BrowserRouter>
      <Wrapper>
        <Navbar/>
        <AuthProviderLoging exemptHrefs={['/login', '/logout']}>
          <div style={{minHeight: 'calc(100vh - 120px)'}}>
            <Routes>
              <Route path="/" element={<HomePage/>} />
              <Route path='/login' element={<LoginPage/>} />
              <Route path='/logout' element={<LogoutPage/>} />
              <Route path='/users' element={<HasPermissions permision={'user-reader'}><UsersPage/></HasPermissions>} />
              <Route path='/balance' element={<HasPermissions permision={'balance-reader'}><BalancePage/></HasPermissions>} />
              <Route path='/mails' element={<HasPermissions permision={'mail-reader'}><Mails/></HasPermissions>}/>
              <Route path='/mails/local' element={<HasPermissions permision={'mail-reader'}><LocalMails/></HasPermissions>}/>
              <Route path='mails/details' element={<HasPermissions permision={'mail-reader'}><MailDetails/></HasPermissions>}/>
              <Route path='/solutions' element={<SolutionsPage/>}/>
              <Route path='/solutions/:id' element={<SolutionPage/>}/>
              <Route path='*' element={<NotFoundPage/>}/>
            </Routes>
          </div>
        </AuthProviderLoging>
      </Wrapper>
      <Footer/>
    </BrowserRouter>
  </div>
);

reportWebVitals();
